import { render, staticRenderFns } from "./MultiColumnText.vue?vue&type=template&id=66ad1412&scoped=true&lang=pug&"
import script from "./MultiColumnText.vue?vue&type=script&lang=js&"
export * from "./MultiColumnText.vue?vue&type=script&lang=js&"
import style0 from "./MultiColumnText.vue?vue&type=style&index=0&id=66ad1412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad1412",
  null
  
)

export default component.exports